import { projectService } from '@/services/project/project-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useProjectNotesDataQuery = (
  projectId: MaybeRefOrGetter<string>,
) => {
  const id = computed(() => toValue(projectId));
  return useQuery({
    queryKey: computed(() => projectKeys.notes({ projectId: id.value })),
    queryFn: async () => projectService.getProjectNotes(id.value),
  });
};
